import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("path", {
  d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
}), ___EmotionJSX("polyline", {
  points: "22,6 12,13 2,6"
}));
export default SVG;